export default __webpack_public_path__ + "static/tc4300_hapAC-82cf704011e30df09be60a0e8638d3e9.jpg";